import RESTSerializer from '@ember-data/serializer/rest'
import { underscore } from '@ember/string'

export default class AssignmentSerializer extends RESTSerializer {
  primaryKey = 'assignment_uuid'

  keyForAttribute(attr: string) {
    return underscore(attr)
  }

  /* For some reason, without these passthrough functions, anything extending this class can't access the parent class
   * functions like payloadKeyFromModelName etc */
  serializeIntoHash(
    ...args: Parameters<(typeof RESTSerializer)['serializeIntoHash']>
  ): ReturnType<(typeof RESTSerializer)['serializeIntoHash']> {
    return super.serializeIntoHash(...args)
  }
}
